import { stepsConfigFlat } from '../components/Stepper/stageConfig';

export const isValidId = id => {
  return id && typeof id === 'string' && id !== 'null' && id !== 'undefined' && id.trim() !== '';
};

/**
 * Redirects the user to the last saved step in a multi-step process if they attempt to access a step beyond their progress.
 *
 * @param {number|string} lastStepSaved - The last step the user has saved progress on.
 * @param {string|number} postingId - The unique identifier for the posting.
 * @param {object} history - The history object used for navigation (e.g., from React Router).
 * @param {Array<string>} [params=[]] - Additional query parameters to append to the URL.
 * @param {string} [currentStepPath] - The path of the current step being accessed.
 *
 * @returns {void}
 */
export const lastStepGuardHelper = (lastStepSaved, postingId = '', history, params = [], currentStepPath) => {
  const isValidPostingId = isValidId(postingId);
  const nLastStep = Number(lastStepSaved);
  const paramsFromURI = new URLSearchParams(window.location.search);
  const paramsURIList = Array.from(paramsFromURI.entries())
    .map(([key, value]) => `${key}=${value}`)
    .filter(item => !item.includes('postingId'));
  if (currentStepPath) {
    const currentStep = stepsConfigFlat.find(item => item.path === currentStepPath);
    if (nLastStep >= currentStep?.stepId) {
      return;
    }
  }
  const nextStepId = nLastStep === stepsConfigFlat?.length ? nLastStep : nLastStep + 1;
  // si el nextStepId es 1, significa que es edicion de un borrador del publicador viejo y tiene que ir al paso 2
  const pathToLastStepSaved = stepsConfigFlat.find(item => item.stepId === (nextStepId === 1 ? 2 : nextStepId));
  const finalParams = [...params, ...paramsURIList];
  if (pathToLastStepSaved) {
    const finalPath = `${pathToLastStepSaved.path}${isValidPostingId ? `?postingId=${postingId}` : ''}${
      finalParams.length > 0 ? '&' : ''
    }${finalParams?.join('&')}`;
    history.push(finalPath);
  }
};
